import { lazy } from 'react';
import { authRoles } from 'app/auth';
import FeatureGuard from 'app/shared-components/FeatureGuard';
import { PlusFeatureGate } from 'app/shared-components/PlusPaywall';
import SuperLinksPaywall from './components/SuperLinksPaywall';

const SuperLinksPage = lazy(() => import('./SuperLinksPage'));

const SuperLinksConfig = {
  settings: {
    layout: {
      config: {
        topBanner: {
          display: true,
        },
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
            background: 'featured',
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'super-links',
      element: (
        <FeatureGuard flag="super_links">
          <PlusFeatureGate feature="superLinks" title="Super links" paywall={<SuperLinksPaywall />}>
            <SuperLinksPage />
          </PlusFeatureGate>
        </FeatureGuard>
      ),
    },
  ],
};

export default SuperLinksConfig;
